module.exports = __webpack_public_path__ + "img/logo.857a1af1.png";